import { UiQuoteline } from '../../../../components/ccam/QuoteLineForm/QuoteLineForm.model'

const all = ['quotelines']
const preview = (quoteLine: UiQuoteline) => [...all, quoteLine]

export const quoteLinesKeys = {
  all,
  preview,
}
